<template>
  <v-row>
    <v-col cols="12">
      <v-tabs v-model="tab">
        <v-tabs-slider></v-tabs-slider>
        <v-tab href="#generate">
          Generate Public/Private Keys
        </v-tab>
        <v-tab href="#import">
          Import SSH Key
        </v-tab>
      </v-tabs>
      <v-tabs-items v-model="tab">
        <!-- Generate Public Key -->
        <v-tab-item value="generate">
          <gg-card>
            <gg-card-header>
              Generate Key Pair
            </gg-card-header>
            <gg-card-text class="pt-0">
              <p class="mb-2">
                RSA vs DSA: RSA and DSA are encryption algorithms used to encrypt your key. DSA is faster for Key
                Generation and Signing and RSA is faster for Verification.
              </p>
              <generate-public-key-form @reload-tables="reloadTables" />
            </gg-card-text>
          </gg-card>
        </v-tab-item>
        <!-- Import SSH Key -->
        <v-tab-item value="import">
          <gg-card>
            <gg-card-header>
              Import SSH Key
            </gg-card-header>
            <gg-card-text class="pt-0">
              <p class="mb-2">
                You may have already generated an SSH public/private key pair. If so, you can import them here, simply
                paste the keys into fields below.
              </p>
              <import-key-form @reload-tables="reloadTables" />
            </gg-card-text>
          </gg-card>
        </v-tab-item>
      </v-tabs-items>
    </v-col>
    <!-- Public Keys -->
    <v-col cols="12">
      <gg-card>
        <gg-card-header>
          Manage Public Keys
        </gg-card-header>
        <gg-card-text>
          <public-keys-table
            :table-should-be-reloaded="publicTableShouldBeReloaded"
            @table-reloaded="tableReloaded" />
          <p class="mb-0">
            <strong>NOTE</strong>: If you authorize a key that is identical to other keys, those keys may also
            become authorized.
          </p>
        </gg-card-text>
      </gg-card>
    </v-col>
    <!-- Private Keys -->
    <v-col cols="12">
      <gg-card>
        <gg-card-header>
          Manage Private Keys
        </gg-card-header>
        <gg-card-text>
          <private-keys-table
            :table-should-be-reloaded="privateTableShouldBeReloaded"
            @table-reloaded="tableReloaded" />
        </gg-card-text>
      </gg-card>
    </v-col>
  </v-row>
</template>

<script>
import PublicKeysTable from '@/components/Services/Hosting/Shared/Ssh/PublicKeysTable'
import PrivateKeysTable from '@/components/Services/Hosting/Shared/Ssh/PrivateKeysTable'
import GeneratePublicKeyForm from '@/components/Services/Hosting/Shared/Ssh/GeneratePublicKeyForm'
import ImportKeyForm from '@/components/Services/Hosting/Shared/Ssh/ImportKeyForm'

export default {
  name: 'SshAccessView',
  components: {
    PublicKeysTable,
    PrivateKeysTable,
    GeneratePublicKeyForm,
    ImportKeyForm,
  },
  data () {
    return {
      publicTableShouldBeReloaded: false,
      privateTableShouldBeReloaded: false,
      tab: null
    }
  },
  methods: {
    reloadTables ({ publicTable = false, privateTable = false }) {
      this.privateTableShouldBeReloaded = privateTable
      this.publicTableShouldBeReloaded = publicTable
    },
    tableReloaded ({ publicTable = false, privateTable = false }) {
      if (publicTable) {
        this.publicTableShouldBeReloaded = false
      }
      if (privateTable) {
        this.privateTableShouldBeReloaded = false
      }
    },
  },
}
</script>
